import React, { useState } from "react";
import { Tab } from "semantic-ui-react";
import { ListRiskTypes } from "../../../components/Admin/RiskTypes/ListRiskTypes/ListRiskTypes";
import { useLanguage } from "../../../contexts";
import "./RiskTypes.scss";

export function RiskTypes() {
  const [reload, setReload] = useState(false);
  const onReload = () => setReload((prev) => !prev);
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  const panes = [
    {
      menuItem: t("actives"),
      render: () => (
        <Tab.Pane attached={false}>
          <ListRiskTypes active={true} reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: t("inactives"),
      render: () => (
        <Tab.Pane attached={false}>
          <ListRiskTypes active={false} reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <div className="risk-types-page" style={{ padding: "0 0 1.5rem" }}>
      <div className="risk-types-page-header-wrapper">
        <div className="risk-types-page-header">
          <span className="risk-types-page-title">{t("risk_types")}</span>
        </div>
      </div>
      <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
    </div>
  );
}
